import Accordion from 'entities/Accordion'
import { Country } from 'features/_SetupFeatures/Country'
import { GoogleMapURL } from 'features/_SetupFeatures/GoogleMapURL'
import { Mail } from 'features/_SetupFeatures/Mail/indes'
import { Phone } from 'features/_SetupFeatures/Phone'
import { Street } from 'features/_SetupFeatures/Street'
import { Town } from 'features/_SetupFeatures/Town'
import { Website } from 'features/_SetupFeatures/Website'
import { ZipCode } from 'features/_SetupFeatures/ZipCode'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'

export const AddressAccordion = () => {
  return (
    <Accordion title='Address'>
      <TwoColumnedDiv>
        <Country />
        <Town />
        <Street />
        <ZipCode />
        <Website />
        <Phone />
        <GoogleMapURL />
        <Mail />
      </TwoColumnedDiv>
    </Accordion>
  )
}
